import { render, staticRenderFns } from "./createprintmodal.vue?vue&type=template&id=0ba9df46&"
import script from "./createprintmodal.vue?vue&type=script&lang=ts&"
export * from "./createprintmodal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createprintmodal.vue"
export default component.exports